export default {
  title: 'Edit your profile',
};
